import {defineStore} from 'pinia'

export const languagesStore = defineStore('languagesStore', {
    state: () => ({
        items: null
    }),
    getters: {
        languages(state) {
            return state.items
        }
    },
    actions: {
        async loadLanguages() {
            const response = await axios.get(`/api/languages`);

            this.items = response.data
        }
    },
})
